import { useEffect, useState } from "react";
import { connect } from 'react-redux';
import { useHistory, useLocation } from "react-router-dom";

import Topbar from './components/Topbar';
import Sidebar from "./components/Sidebar";
import TokenDetailReportCard from "../../admin/components/report/TokenDetailReportCard";

const TokenDetail = ({ token, distributor }) => {

	const history = useHistory();
	const location = useLocation();

	const [toggled, setToggled] = useState(false);

	useEffect(() => {
		if (!location.state || !distributor || !distributor.token_report) {
			history.push('/distributor')
		}
	}, [])

	const handleToggle = () => {
		setToggled(!toggled);
	}

	return (
		<div className="admin-page-container">
			<Sidebar toggled={toggled} setToggled={handleToggle} />
			<div className="admin-page">
				<Topbar handleToggle={handleToggle} />
				<div className="admin-content">
					<TokenDetailReportCard
						token={token}
					/>
				</div>
			</div>
		</div>
	);
}

const mapStateToProps = state => {
	return {
		token: state.distributor.token,
		distributor: state.distributor.distributor
	};
};

export default connect(mapStateToProps, null)(TokenDetail);
